import isomorphicFetch from 'isomorphic-fetch';
import { stringify } from 'qs';
import _ from 'lodash';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var objectSpread = _objectSpread;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck;

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        prototype[method] = function (arg) {
          return this._invoke(method, arg);
        };
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;

        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return Promise.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return Promise.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new Promise(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList) {
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports);

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});
var regenerator = runtime_1;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var asyncToGenerator = _asyncToGenerator;

function objectKeysToSnakeCase(obj) {
  return _.mapKeys(obj, function (v, k) {
    return _.snakeCase(k);
  });
}

function formatQueryString(pageNumber) {
  var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
  var sortField = arguments.length > 2 ? arguments[2] : undefined;
  var sortOrder = arguments.length > 3 ? arguments[3] : undefined;
  var searchQuery = arguments.length > 4 ? arguments[4] : undefined;
  var filters = arguments.length > 5 ? arguments[5] : undefined;
  var extraQueries = arguments.length > 6 ? arguments[6] : undefined;
  var order = sortOrder === 'descend' ? '-' : '';
  var sort = sortOrder && sortField && "".concat(order).concat(sortField);
  var obj = objectSpread({
    page: {
      number: pageNumber,
      size: pageSize
    },
    sort: sort,
    search: searchQuery && searchQuery.length > 0 ? searchQuery : null
  }, objectKeysToSnakeCase(filters), objectKeysToSnakeCase(extraQueries));

  var compactedObj = _.pickBy(obj);

  return stringify(compactedObj);
}

var resource = 'patients';
var PatientsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource, "/api/".concat(resource), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource, "/api/".concat(resource, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource, "/api/".concat(resource, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource, "/api/".concat(resource, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery, extraQueries) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery, extraQueries);
              _context5.next = 3;
              return this.request(resource, "/api/".concat(resource, "?").concat(queryString));

            case 3:
              return _context5.abrupt("return", _context5.sent);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9, _x10) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$1 = 'care_plans';
var CarePlansApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$1, "/api/".concat(resource$1), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$1, "/api/".concat(resource$1, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$1, "/api/".concat(resource$1, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$1, "/api/".concat(resource$1, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(_ref) {
      var pageNumber, pageSize, sortField, sortOrder, searchQuery, filters, queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              pageNumber = _ref.pageNumber, pageSize = _ref.pageSize, sortField = _ref.sortField, sortOrder = _ref.sortOrder, searchQuery = _ref.searchQuery, filters = _ref.filters;
              queryString = formatQueryString(pageNumber, pageSize, sortField, sortOrder, searchQuery, filters);
              return _context5.abrupt("return", this.request(resource$1, "/api/".concat(resource$1, "?").concat(queryString)));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$2 = 'care_plan_activities';
var parentResource$1 = 'care_plans';
var CarePlanActivitiesApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(parentId, params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$2, "/api/".concat(parentResource$1, "/").concat(parentId, "/").concat(resource$2), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x, _x2) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(parentId, id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$2, "/api/".concat(parentResource$1, "/").concat(parentId, "/").concat(resource$2, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x3, _x4) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(parentId, id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$2, "/api/".concat(parentResource$1, "/").concat(parentId, "/").concat(resource$2, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x5, _x6, _x7) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(parentId, id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$2, "/api/".concat(parentResource$1, "/").concat(parentId, "/").concat(resource$2, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x8, _x9) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(parentId, pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request(resource$2, "/api/".concat(parentResource$1, "/").concat(parentId, "/").concat(resource$2, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x10, _x11, _x12, _x13, _x14) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$3 = 'email_templates';
var EmailTemplatesApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$3, "/api/".concat(resource$3), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$3, "/api/".concat(resource$3, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$3, "/api/".concat(resource$3, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$3, "/api/".concat(resource$3, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request(resource$3, "/api/".concat(resource$3, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$4 = 'auth';
var AuthApi = Object.assign({
  readInvitation: function () {
    var _readInvitation = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(token) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.requestPublic(resource$4, "/api/auth/invitations?invitation_token=".concat(token)));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function readInvitation(_x) {
      return _readInvitation.apply(this, arguments);
    }

    return readInvitation;
  }(),
  acceptInvitation: function () {
    var _acceptInvitation = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(token, params) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.requestPublic(resource$4, '/api/auth/invitations', {
                method: 'PUT',
                body: {
                  accept_invitation: objectSpread({}, params, {
                    invitation_token: token
                  })
                }
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function acceptInvitation(_x2, _x3) {
      return _acceptInvitation.apply(this, arguments);
    }

    return acceptInvitation;
  }(),
  resendInvitation: function () {
    var _resendInvitation = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, _ref) {
      var email, role, redirect_uri;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              email = _ref.email, role = _ref.role, redirect_uri = _ref.redirect_uri;
              return _context3.abrupt("return", this.request(resource$4, "/api/auth/invitations/".concat(id), {
                method: 'POST',
                body: {
                  invite: {
                    email: email,
                    role: role,
                    redirect_uri: redirect_uri
                  }
                }
              }, false));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function resendInvitation(_x4, _x5) {
      return _resendInvitation.apply(this, arguments);
    }

    return resendInvitation;
  }(),
  sendUsername: function () {
    var _sendUsername = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(params) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.requestPublic(resource$4, '/api/auth/usernames', {
                method: 'POST',
                body: {
                  user: objectSpread({}, params)
                }
              }, false));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function sendUsername(_x6) {
      return _sendUsername.apply(this, arguments);
    }

    return sendUsername;
  }(),
  changePassword: function () {
    var _changePassword = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(_ref2) {
      var newPassword, newPasswordConfirmation, currentPassword;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              newPassword = _ref2.newPassword, newPasswordConfirmation = _ref2.newPasswordConfirmation, currentPassword = _ref2.currentPassword;
              return _context5.abrupt("return", this.request(resource$4, '/api/auth/passwords', {
                method: 'PUT',
                body: {
                  password: newPassword,
                  password_confirmation: newPasswordConfirmation,
                  current_password: currentPassword
                }
              }, false));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function changePassword(_x7) {
      return _changePassword.apply(this, arguments);
    }

    return changePassword;
  }(),
  sendPassword: function () {
    var _sendPassword = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee6(params) {
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.requestPublic(resource$4, '/api/auth/passwords', {
                method: 'POST',
                body: {
                  username: params.username,
                  redirect_uri: this.reactAppSiteUrl
                }
              }, false));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function sendPassword(_x8) {
      return _sendPassword.apply(this, arguments);
    }

    return sendPassword;
  }(),
  validateRegistrationCode: function () {
    var _validateRegistrationCode = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee7(params) {
      return regenerator.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this.requestPublic(resource$4, '/api/registration_codes/validate', {
                method: 'POST',
                body: params
              }, false));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function validateRegistrationCode(_x9) {
      return _validateRegistrationCode.apply(this, arguments);
    }

    return validateRegistrationCode;
  }(),
  registerPatient: function () {
    var _registerPatient = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee8(params) {
      return regenerator.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", this.requestPublic(resource$4, '/api/auth/patients', {
                method: 'POST',
                body: params
              }, false));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function registerPatient(_x10) {
      return _registerPatient.apply(this, arguments);
    }

    return registerPatient;
  }()
});
var resource$5 = 'templates';
var TemplatesApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request('care_plans', "/api/".concat(resource$5), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request('care_plans', "/api/".concat(resource$5, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request('care_plans', "/api/".concat(resource$5, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request('care_plans', "/api/".concat(resource$5, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request('care_plans', "/api/".concat(resource$5, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9) {
      return _search.apply(this, arguments);
    }

    return search;
  }(),
  applyTemplate: function () {
    var _applyTemplate = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee6(params) {
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.request('care_plans', '/api/apply_templates', {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function applyTemplate(_x10) {
      return _applyTemplate.apply(this, arguments);
    }

    return applyTemplate;
  }()
});
var resource$6 = 'template_activities';
var parentResource$2 = 'templates';
var TemplateActivitiesApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(parentId, params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$6, "/api/".concat(parentResource$2, "/").concat(parentId, "/").concat(resource$6), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x, _x2) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(parentId, id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$6, "/api/".concat(parentResource$2, "/").concat(parentId, "/").concat(resource$6, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x3, _x4) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(parentId, id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$6, "/api/".concat(parentResource$2, "/").concat(parentId, "/").concat(resource$6, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x5, _x6, _x7) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(parentId, id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$6, "/api/".concat(parentResource$2, "/").concat(parentId, "/").concat(resource$6, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x8, _x9) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(parentId, pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request(resource$6, "/api/".concat(parentResource$2, "/").concat(parentId, "/").concat(resource$6, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x10, _x11, _x12, _x13, _x14) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$7 = 'workflows';
var WorkflowsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$7, "/api/".concat(resource$7), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$7, "/api/".concat(resource$7, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$7, "/api/".concat(resource$7, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$7, "/api/".concat(resource$7, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request(resource$7, "/api/".concat(resource$7, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9) {
      return _search.apply(this, arguments);
    }

    return search;
  }(),
  options: function () {
    var _options = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee6() {
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.request(resource$7, "/api/".concat(resource$7, "/options/")));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function options() {
      return _options.apply(this, arguments);
    }

    return options;
  }()
});
var resource$8 = 'actions';
var WorkflowActionsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$8, "/api/workflows/".concat(resource$8), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$8, "/api/workflows/".concat(resource$8, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$8, "/api/workflows/".concat(resource$8, "/").concat(id), {
                method: 'PATCH',
                body: objectSpread({}, params)
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$8, "/api/workflows/".concat(resource$8, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request(resource$8, "/api/workflows/".concat(resource$8, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$9 = 'triggered_actions';
var WorkflowTriggersApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$9, "/api/workflows/".concat(resource$9), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$9, "/api/workflows/".concat(resource$9, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$9, "/api/workflows/".concat(resource$9, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$9, "/api/workflows/".concat(resource$9, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request(resource$9, "/api/workflows/".concat(resource$9, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$a = 'practitioners';
var PractitionersApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$a, "/api/".concat(resource$a), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$a, "/api/".concat(resource$a, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$a, "/api/".concat(resource$a, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$a, "/api/".concat(resource$a, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery, extraQueries) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery, extraQueries);
              return _context5.abrupt("return", this.request(resource$a, "/api/".concat(resource$a, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9, _x10) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$b = 'profile';
var ProfileApi = Object.assign({
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$b, "/api/".concat(resource$b)));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function read() {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(params) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$b, "/api/".concat(resource$b), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function update(_x) {
      return _update.apply(this, arguments);
    }

    return update;
  }()
});
var resource$c = 'questionnaires';
var QuestionnairesApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$c, "/api/".concat(resource$c), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$c, "/api/".concat(resource$c, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$c, "/api/".concat(resource$c, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$c, "/api/".concat(resource$c, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request(resource$c, "/api/".concat(resource$c, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$d = 'questionnaire_responses';
var parentResource$3 = 'care_plan_activities';
var QuestionnaireResponsesApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(parentId, params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$d, "/api/".concat(parentResource$3, "/").concat(parentId, "/").concat(resource$d), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x, _x2) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(parentId, id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$d, "/api/".concat(parentResource$3, "/").concat(parentId, "/").concat(resource$d, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x3, _x4) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(parentId, id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$d, "/api/".concat(parentResource$3, "/").concat(parentId, "/").concat(resource$d, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x5, _x6, _x7) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(parentId, id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$d, "/api/".concat(parentResource$3, "/").concat(parentId, "/").concat(resource$d, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x8, _x9) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(parentId, pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request(resource$d, "/api/".concat(parentResource$3, "/").concat(parentId, "/").concat(resource$d, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x10, _x11, _x12, _x13, _x14) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$e = 'questionnaire_items';
var parentResource$4 = 'questionnaires';
var QuestionnaireItemsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(parentId, params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$e, "/api/".concat(parentResource$4, "/").concat(parentId, "/").concat(resource$e), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x, _x2) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(parentId, id, params) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$e, "/api/".concat(parentResource$4, "/").concat(parentId, "/").concat(resource$e, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function update(_x3, _x4, _x5) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(parentId, id) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$e, "/api/".concat(parentResource$4, "/").concat(parentId, "/").concat(resource$e, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function _delete(_x6, _x7) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }()
});
var resource$f = 'contents';
var ContentsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$f, "/api/".concat(resource$f), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$f, "/api/".concat(resource$f, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$f, "/api/".concat(resource$f, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$f, "/api/".concat(resource$f, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(_ref) {
      var pageNumber, pageSize, sortField, sortOrder, searchQuery, filters, extraQueries, queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              pageNumber = _ref.pageNumber, pageSize = _ref.pageSize, sortField = _ref.sortField, sortOrder = _ref.sortOrder, searchQuery = _ref.searchQuery, filters = _ref.filters, extraQueries = _ref.extraQueries;
              queryString = formatQueryString(pageNumber, pageSize, sortField, sortOrder, searchQuery, objectSpread({}, extraQueries, {
                filters: filters
              }));
              return _context5.abrupt("return", this.request(resource$f, "/api/".concat(resource$f, "?").concat(queryString)));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$g = 'appointments';
var AppointmentsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$g, "/api/".concat(resource$g), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$g, "/api/".concat(resource$g, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$g, "/api/".concat(resource$g, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$g, "/api/".concat(resource$g, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(_ref) {
      var pageNumber, pageSize, sortField, sortOrder, searchQuery, filters, queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              pageNumber = _ref.pageNumber, pageSize = _ref.pageSize, sortField = _ref.sortField, sortOrder = _ref.sortOrder, searchQuery = _ref.searchQuery, filters = _ref.filters;
              queryString = formatQueryString(pageNumber, pageSize, sortField, sortOrder, searchQuery, filters);
              return _context5.abrupt("return", this.request(resource$g, "/api/".concat(resource$g, "?").concat(queryString)));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$h = 'encounters';
var EncountersApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$h, "/api/".concat(resource$h), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$h, "/api/".concat(resource$h, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$h, "/api/".concat(resource$h, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$h, "/api/".concat(resource$h, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(_ref) {
      var pageNumber, pageSize, sortField, sortOrder, searchQuery, filters, queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              pageNumber = _ref.pageNumber, pageSize = _ref.pageSize, sortField = _ref.sortField, sortOrder = _ref.sortOrder, searchQuery = _ref.searchQuery, filters = _ref.filters;
              queryString = formatQueryString(pageNumber, pageSize, sortField, sortOrder, searchQuery, filters);
              return _context5.abrupt("return", this.request(resource$h, "/api/".concat(resource$h, "?").concat(queryString)));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$i = 'communications';
var CommunicationsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$i, "/api/".concat(resource$i), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$i, "/api/".concat(resource$i, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$i, "/api/".concat(resource$i, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$i, "/api/".concat(resource$i, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request(resource$i, "/api/".concat(resource$i, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$j = 'locations';
var LocationsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$j, "/api/".concat(resource$j), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$j, "/api/".concat(resource$j, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$j, "/api/".concat(resource$j, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$j, "/api/".concat(resource$j, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request(resource$j, "/api/".concat(resource$j, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$k = 'media';
var MediaApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$k, "/api/".concat(resource$k), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$k, "/api/".concat(resource$k, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$k, "/api/".concat(resource$k, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$k, "/api/".concat(resource$k, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request(resource$k, "/api/".concat(resource$k, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$l = 'media_assets';
var MediaAssetsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$l, "/api/".concat(resource$l), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$l, "/api/".concat(resource$l, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$l, "/api/".concat(resource$l, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$l, "/api/".concat(resource$l, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request(resource$l, "/api/".concat(resource$l, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$m = 'organizations';
var OrganizationsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$m, "/api/".concat(resource$m), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$m, "/api/".concat(resource$m, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$m, "/api/".concat(resource$m, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$m, "/api/".concat(resource$m, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request(resource$m, "/api/".concat(resource$m, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$n = 'users';
var UsersApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$n, "/api/".concat(resource$n), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$n, "/api/".concat(resource$n, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$n, "/api/".concat(resource$n, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$n, "/api/".concat(resource$n, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery, filters, extraQueries) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery, filters, extraQueries);
              return _context5.abrupt("return", this.request(resource$n, "/api/".concat(resource$n, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9, _x10, _x11) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$o = 'tags';
var ResourceTagsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(id, resourceType, params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$o, "/api/".concat(resourceType, "/").concat(id, "/").concat(resource$o), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x, _x2, _x3) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id, resourceType, params) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$o, "/api/".concat(resourceType, "/").concat(id, "/").concat(resource$o), {
                method: 'DELETE',
                body: params
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function _delete(_x4, _x5, _x6) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              _context3.next = 3;
              return this.request(resource$o, "/api/".concat(resource$o, "?").concat(queryString));

            case 3:
              return _context3.abrupt("return", _context3.sent);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function search(_x7, _x8, _x9, _x10) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$p = 'parent_organizations';
var ParentOrganizationsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$p, "/api/".concat(resource$p), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$p, "/api/".concat(resource$p, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$p, "/api/".concat(resource$p, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$p, "/api/".concat(resource$p, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(pageNumber, sortField, sortOrder, searchQuery) {
      var queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryString = formatQueryString(pageNumber, 25, sortField, sortOrder, searchQuery);
              return _context5.abrupt("return", this.request(resource$p, "/api/".concat(resource$p, "?").concat(queryString)));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6, _x7, _x8, _x9) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$q = 'episodes_of_care';
var EpisodesOfCareApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$q, "/api/".concat(resource$q), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$q, "/api/".concat(resource$q, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$q, "/api/".concat(resource$q, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$q, "/api/".concat(resource$q, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(_ref) {
      var pageNumber, pageSize, sortField, sortOrder, searchQuery, filters, queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              pageNumber = _ref.pageNumber, pageSize = _ref.pageSize, sortField = _ref.sortField, sortOrder = _ref.sortOrder, searchQuery = _ref.searchQuery, filters = _ref.filters;
              queryString = formatQueryString(pageNumber, pageSize, sortField, sortOrder, searchQuery, filters);
              return _context5.abrupt("return", this.request(resource$q, "/api/".concat(resource$q, "?").concat(queryString)));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$r = 'observations';
var ObservationsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$r, "/api/".concat(resource$r), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$r, "/api/".concat(resource$r, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$r, "/api/".concat(resource$r, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$r, "/api/".concat(resource$r, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(_ref) {
      var pageNumber, pageSize, sortField, sortOrder, searchQuery, filters, extraQueries, queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              pageNumber = _ref.pageNumber, pageSize = _ref.pageSize, sortField = _ref.sortField, sortOrder = _ref.sortOrder, searchQuery = _ref.searchQuery, filters = _ref.filters, extraQueries = _ref.extraQueries;
              queryString = formatQueryString(pageNumber, pageSize, sortField, sortOrder, searchQuery, objectSpread({}, extraQueries, {
                filters: filters
              }));
              return _context5.abrupt("return", this.request(resource$r, "/api/".concat(resource$r, "?").concat(queryString)));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$s = 'accounts';
var AccountsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$s, "/api/".concat(resource$s), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$s, "/api/".concat(resource$s, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$s, "/api/".concat(resource$s, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$s, "/api/".concat(resource$s, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(_ref) {
      var pageNumber, pageSize, sortField, sortOrder, searchQuery, filters, extraQueries, queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              pageNumber = _ref.pageNumber, pageSize = _ref.pageSize, sortField = _ref.sortField, sortOrder = _ref.sortOrder, searchQuery = _ref.searchQuery, filters = _ref.filters, extraQueries = _ref.extraQueries;
              queryString = formatQueryString(pageNumber, pageSize, sortField, sortOrder, searchQuery, objectSpread({}, extraQueries, {
                filters: filters
              }));
              return _context5.abrupt("return", this.request(resource$s, "/api/".concat(resource$s, "?").concat(queryString)));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$t = 'users';
var AdminUsersApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$t, "/api/admin/".concat(resource$t), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$t, "/api/admin/".concat(resource$t, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$t, "/api/admin/".concat(resource$t, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  delete: function () {
    var _delete2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(id) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.request(resource$t, "/api/admin/".concat(resource$t, "/").concat(id), {
                method: 'DELETE'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _delete(_x5) {
      return _delete2.apply(this, arguments);
    }

    return _delete;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee5(_ref) {
      var pageNumber, pageSize, sortField, sortOrder, searchQuery, filters, extraQueries, queryString;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              pageNumber = _ref.pageNumber, pageSize = _ref.pageSize, sortField = _ref.sortField, sortOrder = _ref.sortOrder, searchQuery = _ref.searchQuery, filters = _ref.filters, extraQueries = _ref.extraQueries;
              queryString = formatQueryString(pageNumber, pageSize, sortField, sortOrder, searchQuery, objectSpread({}, extraQueries, {
                filters: filters
              }));
              return _context5.abrupt("return", this.request(resource$t, "/api/admin/".concat(resource$t, "?").concat(queryString)));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function search(_x6) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var resource$u = 'client_applications';
var ClientApplicationsApi = Object.assign({
  create: function () {
    var _create = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(params) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(resource$u, "/api/admin/".concat(resource$u), {
                method: 'POST',
                body: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x) {
      return _create.apply(this, arguments);
    }

    return create;
  }(),
  read: function () {
    var _read = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(id) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(resource$u, "/api/admin/".concat(resource$u, "/").concat(id)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read(_x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  update: function () {
    var _update = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(id, params) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.request(resource$u, "/api/admin/".concat(resource$u, "/").concat(id), {
                method: 'PATCH',
                body: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function update(_x3, _x4) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  search: function () {
    var _search = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee4(_ref) {
      var pageNumber, pageSize, sortField, sortOrder, searchQuery, filters, extraQueries, queryString;
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              pageNumber = _ref.pageNumber, pageSize = _ref.pageSize, sortField = _ref.sortField, sortOrder = _ref.sortOrder, searchQuery = _ref.searchQuery, filters = _ref.filters, extraQueries = _ref.extraQueries;
              queryString = formatQueryString(pageNumber, pageSize, sortField, sortOrder, searchQuery, objectSpread({}, extraQueries, {
                filters: filters
              }));
              return _context4.abrupt("return", this.request(resource$u, "/api/admin/".concat(resource$u, "?").concat(queryString)));

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function search(_x5) {
      return _search.apply(this, arguments);
    }

    return search;
  }()
});
var services =
/*#__PURE__*/
Object.freeze({
  patients: PatientsApi,
  care_plans: CarePlansApi,
  care_plan_activities: CarePlanActivitiesApi,
  email_templates: EmailTemplatesApi,
  auth: AuthApi,
  templates: TemplatesApi,
  template_activities: TemplateActivitiesApi,
  workflows: WorkflowsApi,
  actions: WorkflowActionsApi,
  triggered_actions: WorkflowTriggersApi,
  practitioners: PractitionersApi,
  profile: ProfileApi,
  questionnaires: QuestionnairesApi,
  questionnaire_responses: QuestionnaireResponsesApi,
  questionnaire_items: QuestionnaireItemsApi,
  contents: ContentsApi,
  appointments: AppointmentsApi,
  encounters: EncountersApi,
  communications: CommunicationsApi,
  locations: LocationsApi,
  media: MediaApi,
  media_assets: MediaAssetsApi,
  organizations: OrganizationsApi,
  users: UsersApi,
  resource_tags: ResourceTagsApi,
  parent_organizations: ParentOrganizationsApi,
  episodes_of_care: EpisodesOfCareApi,
  observations: ObservationsApi,
  accounts: AccountsApi,
  admin_users: AdminUsersApi,
  client_applications: ClientApplicationsApi
});
var codeMessage = {
  200: 'The server successfully returned the requested data. ',
  201: 'The new or modified data was successful. ',
  202: 'A request has been queued in the background (asynchronous task). ',
  204: 'The data was deleted successfully. ',
  400: 'There was an error in the issued request. The server did not create or modify data. ',
  401: 'User does not have permission (token, username, password is wrong). ',
  403: 'The user is authorized but the access is forbidden. ',
  404: 'The request was issued for a non-existent record and the server did not perform the operation. ',
  406: 'The requested format is not available. ',
  410: 'The requested resource is permanently deleted and will not be regained. ',
  422: 'A validation error occurred while creating an object. ',
  500: 'An error occurred on the server. Please check the server. ',
  502: 'The gateway is wrong. ',
  503: 'The service is unavailable, the server is temporarily overloaded or maintained. ',
  504: 'The gateway timed out. '
};
var TIMEOUT_DURATION = 15 * 1000;

var TimeoutError = function TimeoutError() {
  var error = new Error(codeMessage[504]);
  error.status = 504;
  error.response = {
    status: 504,
    message: 'Request has timed out.'
  };
  return error;
};

var timeout = function timeout(duration) {
  return new Promise(function (res, rej) {
    return setTimeout(function () {
      return rej(TimeoutError());
    }, duration);
  });
};

var checkStatus = function checkStatus(notifyError) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee(response) {
        var jsonResponse, errortext, error;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(response.status >= 200 && response.status < 300)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", response);

              case 2:
                _context.next = 4;
                return response.json();

              case 4:
                jsonResponse = _context.sent;
                errortext = codeMessage[response.status] || response.statusText;

                if (response.status !== 422) {
                  notifyError({
                    message: "Request error ".concat(response.status, ": ").concat(response.url),
                    description: errortext
                  });
                }

                error = new Error(errortext);
                error.status = response.status;
                error.response = jsonResponse;
                throw error;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

function bindChildren(obj, parentKey) {
  var that = this;

  _.forIn(obj, function (val, key) {
    if (_.isObject(val)) {
      that.bindChildren(obj[key], key);
    }

    if (key && parentKey) {
      that[parentKey][key] = that[parentKey][key].bind(that);
    }
  });
}

var baseHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json; charset=utf-8'
};

var Client = function Client() {
  var _this = this;

  var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  classCallCheck(this, Client);
  defineProperty(this, "request",
  /*#__PURE__*/
  function () {
    var _ref2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(resourceType, url, options) {
      var isData,
          session,
          _session,
          accessToken,
          defaultHeaders,
          defaultOptions,
          newOptions,
          race,
          _args2 = arguments;

      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              isData = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : true;
              _context2.prev = 1;
              _context2.next = 4;
              return _this.getCurrentSession();

            case 4:
              session = _context2.sent;
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);

              _this.onUnauthorized();

              return _context2.abrupt("return", Promise.reject(new Error('Token has expired')));

            case 11:
              _session = session, accessToken = _session.accessToken;
              defaultHeaders = {
                Authorization: "Bearer ".concat(accessToken)
              };

              if (_this.headers) {
                defaultHeaders = _this.headers(defaultHeaders);
              }

              defaultOptions = {
                headers: objectSpread({}, defaultHeaders)
              };
              newOptions = objectSpread({}, defaultOptions, options);

              if (_.includes(['POST', 'PUT', 'PATCH', 'DELETE'], newOptions.method)) {
                newOptions.headers = objectSpread({}, baseHeaders, newOptions.headers);

                if (isData) {
                  newOptions.body = JSON.stringify({
                    data: {
                      type: resourceType,
                      attributes: newOptions.body
                    }
                  });
                } else {
                  newOptions.body = JSON.stringify(newOptions.body);
                }
              }

              race = Promise.race([timeout(_this.API_TIMEOUT), isomorphicFetch("".concat(_this.apiUrl).concat(url), newOptions)]);
              return _context2.abrupt("return", race.then(checkStatus(_this.notifyError)).then(function (response) {
                if (newOptions.method === 'DELETE' || response.status === 204) {
                  return response.text();
                }

                return response.json();
              }).catch(_this.onError));

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[1, 7]]);
    }));

    return function (_x2, _x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
  defineProperty(this, "requestPublic",
  /*#__PURE__*/
  function () {
    var _ref3 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(resourceType, url) {
      var options,
          newOptions,
          race,
          _args3 = arguments;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              options = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
              newOptions = options;

              if (_.includes(['POST', 'PUT', 'PATCH'], newOptions.method)) {
                newOptions.headers = objectSpread({}, baseHeaders, newOptions.headers);
                newOptions.body = JSON.stringify(newOptions.body);
              }

              race = Promise.race([timeout(_this.API_TIMEOUT), isomorphicFetch("".concat(_this.apiUrl).concat(url), newOptions)]);
              return _context3.abrupt("return", race.then(checkStatus(_this.notifyError)).then(function (response) {
                if (newOptions.method === 'DELETE' || response.status === 204) {
                  return response.text();
                }

                return response.json();
              }).catch(_this.onError));

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }());
  this.apiUrl = _options.apiUrl;
  this.reactAppSiteUrl = _options.reactAppSiteUrl;
  this.TTL = _options.TTL;
  this.API_TIMEOUT = _options.API_TIMEOUT || TIMEOUT_DURATION;
  this.onUnauthorized = _options.onUnauthorized;
  this.getCurrentSession = _options.getCurrentSession;
  this.notifyError = _options.notifyError;
  this.onError = _options.onError;
  Object.assign(this, services);
  this.bindChildren = bindChildren.bind(this);
  this.bindChildren(this);
  this.headers = _options.headers;
};

export default Client;